<template>
  <div class="massLoss-list">
    <div class="tabs">
      <div @click="typeFun(1)" class="left" :class="{ active: searchForm.type === 1 }">收入</div>
      <div @click="typeFun(2)" class="right" :class="{ active: searchForm.type === 2 }">支出</div>
    </div>
    <div class="nav">
      <el-form :model="searchForm" label-width="110px" :inline="true" class="demo-form-inline flex1" ref="searchForm">
        <el-form-item label="台账月：">
          <el-input v-model="searchForm.standingBookMonth" size="mini" placeholder="请输入台账月" v-if="true"></el-input>
          <el-date-picker v-model="searchForm.standingBookMonth" type="month" placeholder="选择台账月" size="mini" value-format="yyyyMM" v-else> </el-date-picker>
        </el-form-item>
        <el-form-item label="委托商：">
          <el-input v-model="searchForm.consignorName" size="mini" placeholder="请输入委托商"></el-input>
        </el-form-item>
        <el-form-item label="运单类型：">
          <el-select v-model="searchForm.waybillType" filterable size="mini" style="width: 150px" placeholder="请选择运单类型">
            <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn" :loading="searchLoading">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn" :loading="resetLoading">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" v-if="searchForm.type === 1">
          <el-table-column prop="standingBookMonth" label="台账月" align="center" min-width="100px" />
          <el-table-column prop="consignorName" label="委托商" align="center" min-width="80px" />
          <el-table-column prop="waybillType" label="运单类型" align="center" min-width="100px" :formatter="getType" />
          <el-table-column prop="countCar" label="业务数量" align="center" min-width="100px" />
          <el-table-column prop="settlementDocumentCount" label="结算部交单数量" align="center" min-width="150px" />
          <el-table-column prop="incomeSettlementCount" label="收入结算数量" align="center" min-width="150px" />
        </el-table>
        <el-table v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" v-else>
          <el-table-column prop="standingBookMonth" label="台账月" align="center" min-width="100px" />
          <el-table-column prop="consignorName" label="委托商" align="center" min-width="80px" />
          <el-table-column prop="supplierName" label="承运商" align="center" min-width="100px" />
          <el-table-column prop="link" label="环节" align="center" min-width="100px" />
          <el-table-column prop="waybillType" label="运单类型" align="center" min-width="100px" :formatter="getType" />
          <el-table-column prop="countCar" label="业务数量" align="center" min-width="100px" />
          <el-table-column prop="supplierDocumentCount" label="供应商交单数量" align="center" min-width="150px" />
          <el-table-column prop="paySettlementCount" label="支出结算数量" align="center" min-width="150px" />
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.size" />
      </div>
    </div>
  </div>
</template>
<script>
  import { documentAndInvoice } from '@/service/getData';
  export default {
    data() {
      return {
        stateOption: [
          { value: '', label: '全部' },
          { value: 1, label: '电子运单' },
          { value: 2, label: '纸质运单' },
        ],
        searchForm: {
          standingBookMonth: '',
          consignorName: '',
          waybillType: '',
          type: 1,
          size: 10,
          page: 1,
        },
        searchLoading: false,
        resetLoading: false,
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
      };
    },
    methods: {  
      exportData() {
        window.exportExcelAll('get', '/settlementStatement/settlementSchedule/exportExcel', {
          ...this.searchForm
        });
      },
      //收入/支出
      typeFun(val) {
        this.searchForm.type = val;
        this.searchForm.page = 1;
        this.searchForm.size = 10;
        this.tableData = [];
        this.$nextTick(() => {
          this.total = 0;
        });
      },
      getLink(r, c, cellValue) {
        switch (cellValue) {
          case 1:
            return '进港公路';
          case 2:
            return '末端公路';
          case 3:
            return '全公路';
        }
      },
      getType(r, c, cellValue) {
        switch (cellValue) {
          case 1:
            return '电子运单';
          case 2:
            return '纸质运单';
        }
      },
      //查询
      async searchBtn() {
        // console.log(this.searchForm);
        this.searchLoading = true;
        this.searchForm.page = 1;
        this.searchForm.size = 10;
        await this.getTableData();
        this.searchLoading = false;
      },
      async getTableData() {
        this.tableLoading = true;
        const { status, message, data } = await documentAndInvoice(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data ? data.records : [];
        this.total = data ? data.total : 0;
      },
      //重置
      resetBtn() {
        this.resetLoading = true;
        setTimeout(() => {
          this.searchForm.standingBookMonth = '';
          setTimeout(() => {
            this.searchForm.consignorName = '';
            setTimeout(() => {
              this.searchForm.waybillType = '';
              this.resetLoading = false;
            }, 1000);
          }, 1000);
        }, 1000);
      },
      contractSizeChange(row) {
        this.searchForm.size = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
    },
  };
</script>

<style scoped lang="scss">
  .massLoss-list {
    width: 100%;
    padding: 20px 15px 0 25px;
    display: flex;
    flex-direction: column;
    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 150px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599e;
        color: #fff;
      }
    }
  }
</style>
